import * as React from "react";
import {
  Stop,
  Path,
  Rect,
  G,
  Defs,
  ClipPath,
  Mask,
  LinearGradient,
} from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#093"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <G fillRule="evenodd" clipRule="evenodd" filter="url(#c)">
          <Path
            fill="#FFD221"
            d="m7.963 1.852 6.101 4.252-6.184 3.982L1.904 6.02l6.06-4.169Z"
          />
          <Path
            fill="url(#d)"
            d="m7.963 1.852 6.101 4.252-6.184 3.982L1.904 6.02l6.06-4.169Z"
          />
        </G>
        <Path
          fill="#2E42A5"
          fillRule="evenodd"
          d="M8 8.6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
          clipRule="evenodd"
        />
        <Mask
          id="e"
          width={6}
          height={6}
          x={5}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M8 8.6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
            clipRule="evenodd"
          />
        </Mask>
        <G fill="#F7FCFF" mask="url(#e)">
          <Path
            fillRule="evenodd"
            d="m7.19 7.285-.112.059.022-.125-.09-.088.124-.018L7.19 7l.056.113.125.018-.09.088.02.125-.111-.059ZM8.19 7.285l-.112.059.022-.125-.09-.088.124-.018L8.19 7l.056.113.125.018-.09.088.02.125-.111-.059ZM8.19 7.885l-.112.059.022-.125-.09-.088.124-.018.056-.113.056.113.125.018-.09.088.02.125-.111-.059ZM7.69 5.785l-.112.059.022-.125-.09-.088.124-.018.056-.113.056.113.125.018-.09.088.02.125-.111-.059ZM7.69 6.785l-.112.059.022-.125-.09-.088.124-.018.056-.113.056.113.125.018-.09.088.02.125-.111-.059ZM6.99 6.285l-.112.059.022-.125-.09-.088.124-.018L6.99 6l.056.113.125.018-.09.088.02.125-.11-.059ZM6.29 6.685l-.112.059.022-.125-.09-.088.124-.018.056-.113.056.113.125.018-.09.088.02.125-.111-.06ZM8.59 4.985l-.112.059.022-.125-.09-.088.124-.018.056-.113.056.113.125.018-.09.088.02.125-.111-.059Z"
            clipRule="evenodd"
          />
          <Path d="m4.962 5.499.076-.998c2.399.181 4.292.97 5.656 2.373l-.717.697C8.795 6.355 7.131 5.662 4.962 5.5Z" />
        </G>
      </G>
    </G>
    <Defs>
      <LinearGradient
        id="d"
        x1={16}
        x2={16}
        y1={12}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <Stop stopColor="#FFC600" />
        <Stop offset={1} stopColor="#FFDE42" />
      </LinearGradient>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
